import AddResourceForm from "Forms/AddResourceForm";
import React, { Component } from "react";
import { connect } from "react-redux";
import ProfileActions from "Redux/ProfileRedux";
import ProjectActions from "Redux/ProjectRedux";
import styled from "styled-components";
import { Metrics } from "Themes";

const Container = styled.div`
  padding: 20px;
  border: ${Metrics.borders.secondaryBorder};
  border-radius: 5px;
  margin-left: 20px;
  height: 500px;
  background-color: white;
`;

class ProfileDetailsForm extends Component {
  render() {
    const { handleSubmit, profileLinks, resources, customIcon, fetching, success, error } = this.props;
    return (
      <Container>
        <AddResourceForm
          handleSubmit={handleSubmit}
          resources={resources}
          addedResources={profileLinks}
          customIcon={customIcon}
          fetching={fetching}
          error={error}
          success={success}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    getResources: () => dispatch(ProjectActions.getResourcesRequest()),
    getProfileLinks: data =>
      dispatch(ProfileActions.getProfileLinksRequest(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileDetailsForm);
